import styled from 'styled-components';

export const Title = styled.div`
    font-size: 16px;
`;

// Create a Wrapper component that'll render a <section> tag with some styles
export const Wrapper = styled.section`
    background: #ffffff;
`;
